const routerIT = {
    "releases": {
        "view": {
            "name": "Pubblicazioni",
            "buttonText": "Aggiungi Nuova Pubblicazione",
            "secondaryButtonText": "Trasferisci Pubblicazione",
            "headerText": "Pubblicazioni"
        },
        "add": {
            "name": "Aggiungi Nuova Pubblicazione",
            "headerText": "Pubblicazioni"
        },
        "update": {
            "name": "Aggiorna Pubblicazione",
            "headerText": "Pubblicazioni"
        },
        "details": {
            "name": "Dettagli Pubblicazione",
            "headerText": "Pubblicazioni"
        },
        "transfer": {
            "name": "Trasferisci Pubblicazione",
            "headerText": "Pubblicazioni"
        },
        "tracks": {
            "name": "Lista Tracce",
            "headerText": "Pubblicazioni"
        },
        "deliveryConfirmation": {
            "name": "Lista Consegnata",
            "headerText": "Lista Consegnata"
        },
        "storeDeliveryList": {
            "name": "Lista Consegne Negozio",
            "headerText": "Lista Consegne Negozio"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Violazioni del Copyright",
            "headerText": "Violazioni del Copyright"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Portafoglio Escrow",
            "headerText": "Portafoglio Escrow"
        }
    },
    "artists": {
        "view": {
            "name": "Artisti",
            "buttonText": "Aggiungi Nuovo Artista",
            "headerText": "Artisti"
        },
        "add": {
            "name": "Aggiungi Nuovo Artista",
            "headerText": "Artisti"
        },
        "update": {
            "name": "Aggiorna Artista",
            "headerText": "Artisti"
        },
        "viewDetails": {
            "name": "Visualizza Dettagli Artista",
            "headerText": "Visualizza Dettagli Artista"
        },
        "wishlist": {
            "name": "Lista Desideri Artisti",
            "headerText": "Lista Desideri Artisti"
        },
        "addFromWishlist": {
            "name": "Aggiungi Artista dalla Lista Desideri",
            "headerText": "Aggiungi Artista dalla Lista Desideri"
        }
    },
    "trends": {
        "view": {
            "name": "Tendenze",
            "headerText": "Tendenze"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Guadagni",
            "headerText": "Dettaglio Guadagni"
        }
    },
    "accounting": {
        "view": {
            "name": "Contabilità Intelligente",
            "headerText": "Contabilità Intelligente",
            "buttonText": "Aggiungi Nuova Contabilità"
        },
        "add": {
            "name": "Aggiungi Nuova Contabilità",
            "headerText": "Aggiungi Nuova Contabilità"
        },
        "breakdown": {
            "name": "Dettaglio Contabilità",
            "headerText": "Dettaglio Contabilità"
        }
    },
    "invoices": {
        "view": {
            "name": "Fatture",
            "headerText": "Fatture",
            "buttonText": "Aggiungi Fattura"
        },
        "add": {
            "name": "Aggiungi Fattura",
            "headerText": "Aggiungi Fattura"
        }
    },
    "musicLink": {
        "view": {
            "name": "Link Musicale",
            "buttonText": "Aggiungi Nuovo Link Musicale",
            "headerText": "Link Musicale",
            "secondaryButtonText": "Url Link Musicale"
        },
        "add": {
            "name": "Aggiungi Link Musicale",
            "headerText": "Link Musicale"
        },
        "update": {
            "name": "Aggiorna Link Musicale",
            "headerText": "Link Musicale"
        },
        "viewStats": {
            "name": "Statistiche Visualizzazione Link Musicale",
            "headerText": "Statistiche Visualizzazione Link Musicale"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Urlpart Link Musicale",
            "buttonText": "Aggiungi Nuovo Urlpart Link Musicale",
            "headerText": "Urlpart Link Musicale"
        },
        "add": {
            "name": "Aggiungi Nuovo Urlpart Link Musicale",
            "headerText": "Urlpart Link Musicale"
        },
        "update": {
            "name": "Aggiorna Urlpart Link Musicale",
            "headerText": "Urlpart Link Musicale"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Pagina di Atterraggio Link",
            "buttonText": "Aggiungi Pagina di Atterraggio Link",
            "headerText": "Pagina di Atterraggio Link"
        },
        "add": {
            "name": "Aggiungi Pagina di Atterraggio Link",
            "headerText": "Pagina di Atterraggio Link"
        },
        "update": {
            "name": "Aggiorna Pagina di Atterraggio Link",
            "headerText": "Pagina di Atterraggio Link"
        },
        "viewAnalytics": {
            "name": "Analisi Pagina di Atterraggio Link",
            "headerText": "Pagina di Atterraggio Link"
        }
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Aggiungi Mastering",
            "headerText": "Masterizzazione Audio"
        },
        "add": {
            "name": "Aggiungi Mastering",
            "headerText": "Masterizzazione Audio"
        },
        "update": {
            "name": "Aggiorna Mastering",
            "headerText": "Masterizzazione Audio"
        },
        "viewSongs": {
            "name": "Canzoni Masterizzazione Audio",
            "headerText": "Canzoni Masterizzazione Audio"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Richiesta di Funzionalità",
            "buttonText": "Nuova Richiesta di Funzionalità",
            "headerText": "Richiesta di Funzionalità"
        },
        "add": {
            "name": "Aggiungi Richiesta di Funzionalità",
            "headerText": "Richiesta di Funzionalità"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "Whitelist SC",
            "headerText": "Whitelist SC"
        }
    },
    "profile": {
        "view": {
            "name": "Profilo",
            "headerText": "Il Mio Profilo"
        }
    },
    "announcements": {
        "view": {
            "name": "Avvisi",
            "headerText": "Avvisi"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Autenticazione a Due Fattori",
            "headerText": "Autenticazione a Due Fattori"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Completa le Tue Informazioni",
            "headerText": "Completa le Tue Informazioni"
        }
    },
    "tokens": {
        "view": {
            "name": "Token",
            "headerText": "Token"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Ordina Token",
            "headerText": "Ordina Token"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Chiavi di accesso",
            "headerText": "Chiavi di accesso"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Metodi di Pagamento",
            "buttonText": "Aggiungi Metodo di Pagamento",
            "headerText": "I Miei Metodi di Pagamento"
        },
        "add": {
            "name": "Aggiungi Metodo di Pagamento",
            "headerText": "I Miei Metodi di Pagamento"
        },
        "update": {
            "name": "Aggiorna Metodo di Pagamento",
            "headerText": "I Miei Metodi di Pagamento"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Ordina Crediti",
            "headerText": "Ordina Crediti"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Storico Acquisti",
            "headerText": "Storico Acquisti"
        }
    },
    "subscription": {
        "view": {
            "name": "Il Mio Abbonamento",
            "headerText": "Il Mio Abbonamento"
        },
        "upgrade": {
            "name": "Aggiorna Abbonamento",
            "headerText": "Aggiorna Abbonamento"
        }
    },
    "subUsers": {
        "view": {
            "name": "Sotto Utenti",
            "buttonText": "Aggiungi Nuovo Sotto-Utente",
            "headerText": "I Miei Sotto-Utenti"
        },
        "add": {
            "name": "Aggiungi Nuovo Sotto-Utente",
            "headerText": "I Miei Sotto-Utenti"
        },
        "edit": {
            "name": "Modifica Sotto-Utente",
            "headerText": "I Miei Sotto-Utenti"
        }
    },
    "labels": {
        "view": {
            "name": "Etichette",
            "buttonText": "Aggiungi Nuova Etichetta",
            "headerText": "Le Mie Etichette"
        },
        "add": {
            "name": "Aggiungi Nuova Etichetta",
            "headerText": "Le Mie Etichette"
        },
        "edit": {
            "name": "Modifica Etichetta",
            "headerText": "Le Mie Etichette"
        }
    },
    "statements": {
        "view": {
            "name": "Estratti Conto",
            "headerText": "Estratti Conto Finanziari"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Estratti Conto Sotto Utente",
            "headerText": "Estratti Conto Sotto Utente"
        },
        "viewSubuser": {
            "name": "Estratti Conto Utente",
            "headerText": "Estratti Conto Utente"
        }
    },
    "dashboard": {
        "view": {
            "name": "Pagina Iniziale",
            "headerText": "Pagina Iniziale"
        }
    }
};

export default routerIT;